import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Component } from "react";
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import firebase from "firebase";
import "firebase/auth";
import {
    FirebaseAuthProvider,
    IfFirebaseAuthed,
    IfFirebaseUnAuthed,
  } from "@react-firebase/auth";
import { config } from "../../config";
import LangSwitcher from './lang/LangSwitcher'
import { translate } from "react-i18next"

import logo from '../assets/images/logo.png'

class Menu extends Component {
    constructor(props) {
        super(props);
        this.showMessage = this.showMessage.bind(this);
        this.state = 
        {
            message: "",
        };
      }
    
      showMessage(message) {
        this.setState({
            message: message,
        });
      }

      render() {
        const { t } = this.props
        return (
        <StaticQuery
          query={graphql`
            query MenuQuery {
              site {
                siteMetadata {
                  admins
                }
              }
            }
          `}
          render={data => (
            <nav id="menu">
                <div className="inner">
                    <a href="/"><img className="image fit" src={logo} /></a>
                    <ul className="links">
                        <li><Link onClick={this.props.onToggleMenu} to="/">{t("menu_search", "Suche")}</Link></li>
                        <li><Link onClick={this.props.onToggleMenu} to="/womap">{t("menu_womap", "Womap")}</Link></li>
                        {/* {this.props.isApp ? (<li><Link onClick={this.props.onToggleMenu} to="/meeting">{t("footer_meeting", "Meeting")}</Link></li>) : (<></>)} */}
                        <li><Link onClick={this.props.onToggleMenu} to="/faq">{t("menu_faq", "So Funktioniert's")}</Link></li>
                        <li><Link onClick={this.props.onToggleMenu} to="/about">{t("menu_about", "Über uns")}</Link></li>
                        <li><Link onClick={this.props.onToggleMenu} to="/contact">{t("menu_contact", "Kontakt")}</Link></li>
                    </ul>
                        <FirebaseAuthProvider {...config} firebase={firebase}>
                            <IfFirebaseUnAuthed>
                                {() => {
                                    return (
                                        <ul className="actions vertical">
                                            <li><Link className="button special fit" to="/register">{t("menu_register", "Registrieren")}</Link></li>
                                            <li><Link className="button fit" to="/login">{t("menu_login", "Anmelden")}</Link></li>
                                        </ul>
                                    );
                                }}
                            </IfFirebaseUnAuthed>
                            <IfFirebaseAuthed>
                                {(user) => {
                                    return (
                                        <ul className="actions vertical">
                                            <li><Link className="button special fit" to="/profile">{t("menu_profile", "Mein Profil")}</Link></li>
                                            {data.site.siteMetadata.admins.includes(user.user.email) && this.props.isApp ? (<li><Link className="button fit" to="/admin">Admin</Link></li>) : (<></>)}
                                            <li><Link className="button fit" onClick={() => {firebase.auth().signOut();}} to="/">{t("menu_logout", "Abmelden")}</Link></li>
                                        </ul>
                                    );
                                }}
                            </IfFirebaseAuthed>
                        </FirebaseAuthProvider>   
                        <span role="button" tabIndex="0" onClick={this.props.onToggleMenu}><LangSwitcher /></span> 
                </div>
                <a className="close" onClick={this.props.onToggleMenu} role="button" tabIndex="0">Close</a>
            </nav>
          )}
          />
       )
    }
  } 

Menu.propTypes = {
    onToggleMenu: PropTypes.func
}

export default translate("Index")(Menu)